import { configureAfterCareStore } from '@state';
import React from 'react';
import { Provider } from 'react-redux';
import AftercareStepContainer from './AftercareStepContainer';
const store = configureAfterCareStore();
const AftercareLoader = (props) => {
    return (React.createElement(Provider, { store: store },
        React.createElement(AftercareStepContainer, Object.assign({}, props))));
};
export default AftercareLoader;
